module.exports = __webpack_public_path__ + "static/media/garderobe_richtig.406e60e1.jpg";